import { motion } from 'framer-motion'
import Button from './Button'
import BrowserMockup from './BrowserMockup'
import RotatingHeadline from './RotatingHeadline'
import { duration, ease } from '../lib/motion'
import { useFormModal } from '../context/FormModalContext'

export default function Hero() {
  const { openInquiry } = useFormModal()
  return (
    <section id="top" className="relative pt-20 md:pt-28 pb-24 overflow-hidden">
      <div className="container-bw grid grid-cols-1 md:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: duration.slow, ease: ease.out }}
        >
          <p className="eyebrow mb-6">Better Website Co.</p>
          <RotatingHeadline />
          <p
            className="mt-7 text-lg max-w-md"
            style={{ color: 'var(--text-secondary)' }}
          >
            Your website should do more than look good. It should help you win the client.
            Strategy, psychology and design, for businesses ready to be taken seriously.
          </p>
          <p
            className="mt-3 text-sm max-w-md"
            style={{ color: 'var(--text-muted)' }}
          >
            Helping small businesses in the UK, US and beyond get discovered, trusted and chosen online.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Button onClick={() => openInquiry()} variant="primary" ttqTrack>
              Start My Website
            </Button>
            <Button href="#transformations" variant="secondary">
              See the Work
            </Button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: duration.slow, ease: ease.out, delay: 0.15 }}
        >
          <BrowserMockup />
        </motion.div>
      </div>
    </section>
  )
}
